// Created by hejikun on 2017/10/25 0025.

let state = {
  privatelyStarList: [],
  privately_hasMore: false
}

const actions = {
  loadPrivatelyList({ commit }, args) {
    let url = ''
    switch (args.type) {
      case 'privatelyStarList':
        url = `/doctor/comment?hos_id=${args.hos_id}&dep_id=${args.dep_id}&page=${args.page}`
        break
      default:
        return Promise.reject(new Error('请求参数异常'))
    }
    window.axiosBaseApi
      .get(url)
      .then((res) => {
        res.data.code === 1
          ? (() => {
              console.log(res)
              commit({
                type: 'set_privately_list',
                dataType: args.type,
                data: res.data.data,
                page: args.page
              })
            })()
          : commit({
              type: 'set_privately_list',
              dataType: args.type,
              data: []
            })
        return Promise.resolve()
      })
      .catch((e) => {
        return Promise.reject(e)
      })
  }
}

const mutations = {
  set_privately_list(state, args) {
    args.data.length < 10 ? (state.privately_hasMore = false) : (state.privately_hasMore = true)
    if (args.page === 1) {
      if (args.data.length === 0) {
        state[args.dataType] = []
      } else {
        state[args.dataType] = args.data
      }
    } else {
      if (args.data.length !== 0) {
        args.data.forEach((item) => {
          state[args.dataType].push(item)
        })
      }
    }
  }
}

export default {
  state,
  mutations,
  actions
}
